import React from 'react';

const logos = [
    'accutech-logo.webp',
    'astralpool-logo.webp',
    'auo-logo.webp',
    'belrise-logo.webp',
    'Bermad-logo.webp',
    'bhtc-logo.webp',
    'brihans-labs-logo.webp',
    'cnh-logo.webp',
    'cooper-corp-logo.webp',
    'flash-logo.webp',
    'Hyundai-Glovis-Logo.webp',
    'hyundai-logo.webp',
    'Hyundai-transys-Logo.webp',
    'IGW-logo.webp',
    'inverted-logo.webp',
    'mercedes-logo.webp',
    'nippon-express-logo.webp',
    'sany-logo.webp',
    'schwing-stetter-logo.webp',
    'SIGMA-logo.webp',
    'silkee-logo.webp',
    'sl-corporation-logo.webp',
    'timken-logo.webp',
    'tvs-logo.webp',
    'visotec-logo.webp',
    'accutech-logo.webp',
    'astralpool-logo.webp',
    'auo-logo.webp',
    'belrise-logo.webp',
    'Bermad-logo.webp',
    'bhtc-logo.webp',
    'brihans-labs-logo.webp',
    'cnh-logo.webp',
    'cooper-corp-logo.webp',
    'flash-logo.webp',
    'Hyundai-Glovis-Logo.webp',
    'hyundai-logo.webp',
    'Hyundai-transys-Logo.webp',
    'IGW-logo.webp',
    'inverted-logo.webp',
    'mercedes-logo.webp',
    'nippon-express-logo.webp',
    'sany-logo.webp',
    'schwing-stetter-logo.webp',
    'SIGMA-logo.webp',
    'silkee-logo.webp',
    'sl-corporation-logo.webp',
    'timken-logo.webp',
    'tvs-logo.webp',
    'visotec-logo.webp',
    'danfoss-logo.webp',
    'kcc-logo.webp',
    'hyundai_mobis-logo.webp',
    'knorr-bremse-logo.webp'
];

const ClientPartners = () => {
    const repeated = [...logos, ...logos];

    return (
        <section id="clients" className="section flex flex-col items-center gap-10 text-sm md:text-base lg:text-lg overflow-hidden">
            <div className="container section-badge flex justify-center items-center gap-3 text-[16px] md:text-[20px]">
                <div className="badge-dot"></div>
                Clients & Partners
            </div>
            <div className="logo-carousel" aria-label="Clients and Partners logos">
                <div className="logo-track">
                    {repeated.map((file, idx) => (
                        <div className="logo-item" key={`${file}-${idx}`}>
                            <img src={`/images/${file}`} alt="client logo" loading="lazy" />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ClientPartners;


